
export class EntitlementTo {

    id: number;
    name: string;
    displayName: string;
    preferences: Array<String>;
    orgType : string;
    entitlementGroup : string;
    disabledBySafeMode : boolean = false;
    parentEntitlementId : number;

    constructor(object?: any) {
        if (object?.hasOwnProperty('id')) {
            this.id = object?.id;
        }
        this.name = object?.name;
        this.displayName = object?.displayName;
        this.orgType = object?.orgType;
        if (object?.hasOwnProperty('preferences')) {
          this.preferences = object?.preferences;
        }
        this.entitlementGroup = object?.entitlementGroup;
        this.disabledBySafeMode = object?.disabledBySafeMode || false; // Ensure disabledBySafeMode is set
        this.parentEntitlementId = object?.parentEntitlementId;

    }
}
